import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './App.css';
import App from './App';
import AuthService from './services/AuthService';
import registerAxiosInterceptors from './services/RegisterAxiosInterceptors';

registerAxiosInterceptors();

function Root() {
  const [isAuthReady, setIsAuthReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    AuthService.initialize()
      .catch((error) => {
        console.error('Unable to initialize authentication.', error);
        AuthService.logoutLocal();
      })
      .finally(() => mounted && setIsAuthReady(true));
    return () => { mounted = false; };
  }, []);

  if (!isAuthReady) return <div className="session-status" role="status">Checking your session...</div>;
  return <HashRouter><App /></HashRouter>;
}

ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><Root /></React.StrictMode>);
